var _g, _path, _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#infoCircle_svg__filter0_d_6577_166562)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.478,
    cy: 28.651,
    r: 23,
    stroke: "currentColor",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.478 26.538c0-.49-.447-.887-1-.887-.552 0-1 .397-1 .887v9.227c0 .49.448.886 1 .886.553 0 1-.397 1-.886v-9.227z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.478,
    cy: 22.651,
    r: 1,
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "infoCircle_svg__filter0_d_6577_166562",
    x: 0.651,
    y: 0.847,
    width: 93.655,
    height: 93.655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.023
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.414
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.333333 0 0 0 0 0.205499 0 0 0 0 0.0486111 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6577_166562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6577_166562",
    result: "shape"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgODggOTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9kXzY1NzdfMTY2NTYyKSI+DQo8Y2lyY2xlIGN4PSI0Ny40Nzg1IiBjeT0iMjguNjUxNCIgcj0iMjMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHNoYXBlLXJlbmRlcmluZz0iYXV0byIvPg0KPC9nPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00OC40Nzg1IDI2LjUzNzhDNDguNDc4NSAyNi4wNDgyIDQ4LjAzMDggMjUuNjUxNCA0Ny40Nzg1IDI1LjY1MTRDNDYuOTI2MiAyNS42NTE0IDQ2LjQ3ODUgMjYuMDQ4MiA0Ni40Nzg1IDI2LjUzNzhWMzUuNzY1QzQ2LjQ3ODUgMzYuMjU0NSA0Ni45MjYyIDM2LjY1MTQgNDcuNDc4NSAzNi42NTE0QzQ4LjAzMDggMzYuNjUxNCA0OC40Nzg1IDM2LjI1NDUgNDguNDc4NSAzNS43NjVMNDguNDc4NSAyNi41Mzc4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+DQo8Y2lyY2xlIGN4PSI0Ny40Nzg1IiBjeT0iMjIuNjUxNCIgcj0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+DQo8ZGVmcz4NCjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZF82NTc3XzE2NjU2MiIgeD0iMC42NTExNTQiIHk9IjAuODQ2ODA2IiB3aWR0aD0iOTMuNjU0NyIgaGVpZ2h0PSI5My42NTQ3IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+DQo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPg0KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+DQo8ZmVPZmZzZXQgZHk9IjE5LjAyMjgiLz4NCjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjExLjQxMzciLz4NCjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPg0KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC4zMzMzMzMgMCAwIDAgMCAwLjIwNTQ5OSAwIDAgMCAwIDAuMDQ4NjExMSAwIDAgMCAwLjEgMCIvPg0KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfNjU3N18xNjY1NjIiLz4NCjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93XzY1NzdfMTY2NTYyIiByZXN1bHQ9InNoYXBlIi8+DQo8L2ZpbHRlcj4NCjwvZGVmcz4NCjwvc3ZnPg0K";
export { SvgInfoCircle as ReactComponent };